import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a4eaa75"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Iniciar sesión", -1))

import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { RequestLoginDTO } from "@/interfaces/Login";
import { useAuth } from "@/composables/useAuth";
import ErrorLogin from "./ErrorLogin.vue";
import { AxiosResponse } from "axios";
import ResponseLogin from "./ResponseLogin.vue";
import ModalRecordarPass from "./ModalRecordarPass.vue";
import LogoutDialog from "@/components/Commons/LogoutDialog.vue";
import { useBiometria } from "@/composables/useBiometria";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormInicioSesion',
  setup(__props) {

const email = ref("");
const password = ref("");
const { login, getUser } = useAuth();
const biometria = useBiometria();
const router = useRouter();
const dialog = ref(false);
const mensajeError = ref("");
const dialogOk = ref(false);

const isLoading = ref(false);
const showModalRecordarPass = ref(false);
const nombreAcceso = ref("");
const nombreAPreguntar = ref("");

const entrar = async (
  credentials: RequestLoginDTO
): Promise<"dentro" | "rechazado" | "error"> => {
  dialog.value = false;
  dialogOk.value = false;
  isLoading.value = true;

  try {
    const response: string | AxiosResponse = await login(credentials);
    if (typeof response === "string") {
      router.push({ name: "error" });
      return "error";
    }
    if (!response.data.isAccess) {
      mensajeError.value = response.data.mensaje ?? "";
      dialog.value = true;
      return "rechazado";
    }
    return "dentro";
  } catch (error) {
    console.error(error);
    return "error";
  } finally {
    isLoading.value = false;
  }
};

const handleLogin = async () => {
  const resultado = await entrar({
    email: email.value,
    password: password.value,
  });
  if (resultado !== "dentro") return;
  if (await biometria.hayQuePreguntar(getUser.value))
    nombreAPreguntar.value = await biometria.nombreDelAcceso();
  else dialogOk.value = true;
};

const responderBiometria = async (acepta: boolean) => {
  if (acepta) await biometria.activar(getUser.value, password.value);
  nombreAPreguntar.value = "";
  dialogOk.value = true;
};

const mirarAccesoGuardado = async () => {
  nombreAcceso.value = (await biometria.hayAccesoGuardado())
    ? await biometria.nombreDelAcceso()
    : "";
};

onMounted(mirarAccesoGuardado);

const entrarConBiometria = async () => {
  const acceso = await biometria.leerAcceso();
  if (!acceso) return;
  const resultado = await entrar({
    email: acceso.username,
    password: acceso.password,
  });
  if (resultado === "dentro") dialogOk.value = true;
  // Con un mensaje del servidor, como el de demasiados intentos, lo guardado sigue valiendo
  else if (resultado === "rechazado" && !mensajeError.value) {
    // Ha cambiado la contraseña: al entrar escribiendo la nueva se vuelve a preguntar
    mensajeError.value = `Tu contraseña ha cambiado. Entra escribiendo la nueva y podrás volver a activar ${nombreAcceso.value}.`;
    await biometria.desactivar();
    nombreAcceso.value = "";
  }
};

const handleOkClick = () => {
  dialogOk.value = false;
};

const handleForgotPassword = () => {
  showModalRecordarPass.value = true;
};

const closeModal = () => {
  showModalRecordarPass.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "login-form" }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, {
                        onSubmit: _withModifiers(handleLogin, ["prevent"]),
                        ref: "form"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                            label: "Correo electrónico",
                            type: "email",
                            required: "",
                            class: "my-4"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: password.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                            label: "Contraseña",
                            type: "password",
                            required: "",
                            class: "my-4",
                            onKeydown: _withKeys(handleLogin, ["enter"])
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_row, {
                            justify: "center",
                            class: "my-4 ga-5"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "blue darken-1",
                                variant: "tonal",
                                disabled: isLoading.value,
                                size: "large",
                                class: "login-form__button",
                                onClick: handleLogin
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Iniciar sesión ")
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_component_v_btn, {
                                color: "blue darken-1",
                                variant: "tonal",
                                size: "large",
                                to: "registro-usuario",
                                disabled: isLoading.value,
                                class: "login-form__button"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Nuevo usuario ")
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          (nombreAcceso.value)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                justify: "center",
                                class: "my-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    color: "blue darken-1",
                                    variant: "tonal",
                                    size: "large",
                                    "prepend-icon": 
                    nombreAcceso.value === 'Face ID'
                      ? 'mdi-face-recognition'
                      : 'mdi-fingerprint'
                  ,
                                    disabled: isLoading.value,
                                    class: "login-form__button",
                                    onClick: entrarConBiometria
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Entrar con " + _toDisplayString(nombreAcceso.value), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["prepend-icon", "disabled"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (isLoading.value)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 1,
                                justify: "center",
                                class: "mt-3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_progress_linear, {
                                    size: 24,
                                    width: 2,
                                    indeterminate: "",
                                    color: "blue darken-1",
                                    class: "progress-linear-margin"
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_row, {
                            justify: "center",
                            class: "my-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                variant: "text",
                                color: "blue darken-1",
                                onClick: handleForgotPassword,
                                class: "login-form__remember-password"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" ¿Desea recordar la contraseña? ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (dialog.value)
        ? (_openBlock(), _createBlock(ErrorLogin, {
            key: 1,
            isVisible: dialog.value,
            mensaje: mensajeError.value,
            "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (dialog.value = $event))
          }, null, 8, ["isVisible", "mensaje"]))
        : _createCommentVNode("", true),
      (dialogOk.value)
        ? (_openBlock(), _createBlock(ResponseLogin, {
            key: 2,
            isVisible: dialogOk.value,
            "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (dialogOk.value = $event))
          }, null, 8, ["isVisible"]))
        : _createCommentVNode("", true),
      _createVNode(LogoutDialog, {
        isVisible: !!nombreAPreguntar.value,
        persistent: "",
        titulo: `¿Entrar con ${nombreAPreguntar.value} la próxima vez?`,
        mensaje: `No tendrás que escribir la contraseña. Se guarda cifrada en este dispositivo y solo se usa con ${nombreAPreguntar.value}.`,
        textoConfirmar: "Sí",
        textoCancelar: "Ahora no",
        onConfirmar: _cache[4] || (_cache[4] = ($event: any) => (responderBiometria(true))),
        onCancelar: _cache[5] || (_cache[5] = ($event: any) => (responderBiometria(false)))
      }, null, 8, ["isVisible", "titulo", "mensaje"]),
      (showModalRecordarPass.value)
        ? (_openBlock(), _createBlock(ModalRecordarPass, {
            key: 3,
            onClose: closeModal
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})